<template lang="pug">
  .curve-shape-button
    .content
      .top
      .circle
        i.ods-icon-arrow-right
      .bottom
</template>

<script>
export default {
  name: 'CurveShapeButton'
}
</script>

<style lang='scss' scoped>
  .content {
    position: relative;
    // right: 45%;
    // top: 5px;
    pointer-events: none;
    cursor: pointer;
  }
  .top {
    background: #fff;
    height: 40px;
    width: 40px;
    position: absolute;
    border-radius: 50%;
    top: -40px;
    z-index: 1;
  }
  .bottom {
    background: #fff;
    height: 40px;
    width: 40px;
    position: absolute;
    border-radius: 50%;
    bottom: -40px;
    z-index: 1;
  }
  .circle {
    background: #2E6C99;
    height: 40px;
    width: 40px;
    pointer-events: all;
    cursor: pointer;
    margin-right: -1px;
    border-right: 1px solid #2E6C99;
    border-radius: 50% 0 0 50%;
  }
  .circle:after{
    content:'';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: rotate(90deg);
    margin: -10px;
    width: 0;
    height: 0;
    pointer-events: none;
    cursor: default;
    border-top: solid 21px #2E6C99;
    border-left: solid 21px transparent;
    border-right: solid 21px transparent;
  }
  .circle:before{
    content:'';
    position: absolute;
    top: 0%;
    left: 50%;
    transform: rotate(90deg);
    margin: -10px;
    width: 0;
    height: 0;
    pointer-events: none;
    cursor: default;
    border-top: solid 21px #2E6C99;
    border-left: solid 21px transparent;
    border-right: solid 21px transparent;
    border-radius: -50%;
  }
  .ods-icon-arrow-right {
    color: $--color-white;
    position: absolute;
    top: calc(50% - 10.5px);
    left: calc(50% - 10px);
    right: rem(27);
  }
 </style>
